"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTypeEnum = void 0;
/**
 * list of attribute types
 * @export
 * @enum {string}
 */
var DataTypeEnum;
(function (DataTypeEnum) {
    DataTypeEnum["Jdate"] = "JDATE";
    DataTypeEnum["Jdaterange"] = "JDATERANGE";
    DataTypeEnum["Jdatetime"] = "JDATETIME";
    DataTypeEnum["Jdatetimerange"] = "JDATETIMERANGE";
    DataTypeEnum["Jmgmcode"] = "JMGMCODE";
    DataTypeEnum["Javatar"] = "JAVATAR";
    DataTypeEnum["Jnumber"] = "JNUMBER";
    DataTypeEnum["Jselect"] = "JSELECT";
    DataTypeEnum["Gender"] = "GENDER";
    DataTypeEnum["Jfile"] = "JFILE";
    DataTypeEnum["Jtext"] = "JTEXT";
    DataTypeEnum["Jtextarea"] = "JTEXTAREA";
    DataTypeEnum["Jselectmultiple"] = "JSELECTMULTIPLE";
    DataTypeEnum["Jradio"] = "JRADIO";
    DataTypeEnum["Jcheckbox"] = "JCHECKBOX";
    DataTypeEnum["Jprivacy"] = "JPRIVACY";
    DataTypeEnum["Phone"] = "PHONE";
    DataTypeEnum["Jaddress"] = "JADDRESS";
    DataTypeEnum["Place"] = "PLACE";
    DataTypeEnum["Custom"] = "CUSTOM";
    DataTypeEnum["Privacy"] = "PRIVACY";
    DataTypeEnum["Jinvitation"] = "JINVITATION";
    DataTypeEnum["NumbersRange"] = "NUMBERS_RANGE";
    DataTypeEnum["DatesRange"] = "DATES_RANGE";
    DataTypeEnum["AttributeList"] = "ATTRIBUTE_LIST";
    DataTypeEnum["UniqueId"] = "UNIQUE_ID";
    DataTypeEnum["JloyaltyCode"] = "JLOYALTY_CODE";
    DataTypeEnum["Jemail"] = "JEMAIL";
    DataTypeEnum["Jstatus"] = "JSTATUS";
    DataTypeEnum["Jpassword"] = "JPASSWORD";
    DataTypeEnum["Jtaxcode"] = "JTAXCODE";
    DataTypeEnum["Jphone"] = "JPHONE";
    DataTypeEnum["Jcountry"] = "JCOUNTRY";
    DataTypeEnum["Jdiscriminating"] = "JDISCRIMINATING";
})(DataTypeEnum = exports.DataTypeEnum || (exports.DataTypeEnum = {}));
